<template>
  <div class="search-tree ">
    <el-popover placement="bottom-start" v-model="visible" trigger="hover" @hide="cancel">

      <div class="search-tree-content search-tree-category">
        <div class="search-tree-content-left">
          <el-input placeholder="搜索关键词" v-model="filterText"></el-input>
          <div class="el-tree-style1 el-tree-category">
            <el-scrollbar style="height: 100%;">
              <el-tree
                :empty-text="$t('nodata')"
                :data="countryList"
                show-checkbox
                node-key="codeValue"
                :check-on-click-node="true"
                :filter-node-method="filterNode"
                ref="tree"
                :default-expanded-keys="[1]"
                :default-checked-keys="selectList"
                :props="defaultProps"
                @check-change="handleCheckOwner"
              ></el-tree>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <span class="el-dropdown-link" :class="num>0?'activeLink':''" slot="reference">
       区域<span v-if="num">({{num}})</span>
        <i class="el-icon-caret-bottom"></i>
      </span>
    </el-popover>
  </div>
</template>

<script>
import getSimpleCheckedNodes from '@/utils/getsimpleTree.js'
export default {
  props: {
    countryList: {
      type: Array,
      default: null
    },
    selectList: {
      type: Array,
      default: []
    }
  },
  watch: {
    // selectList(newval, oldval) {
    //   console.log(newval);
    // }
  },
  data() {
    return {
      visible: false,
      filterText: "",
      defaultProps: {
        children: "childrenList",
        label: "name"
      },
      ids: this.selectList,
      num: this.selectList?this.selectList.length:0
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
       return data.name.indexOf(value) !== -1;
      // if (this.$i18n.locale === "zh") {
      //   return data.cnName.indexOf(value) !== -1;
      // } else {
      //   return data.enName.toUpperCase().indexOf(value.toUpperCase().trim()) !== -1;
      // }
    },
    handleCheckOwner(data, node) {
      this.num = getSimpleCheckedNodes(this.$refs.tree.store).length;
      // this.ids = getSimpleCheckedNodes(this.$refs.tree.store);
      let obj = { ...this.$route.query};
      if(this.num) {
        obj.region =  getSimpleCheckedNodes(this.$refs.tree.store).join(',')
      } else {
        delete obj.region;
      }
      this.$router.push({
        path: this.$route.path,
        query:obj
      })
      console.log(obj)
    },
    cancel() {
      this.visible = false;
      this.filterText=''
      // this.$refs.tree.setCheckedKeys(this.selectList);
    },
    submit() {
      this.visible = false;
      let obj = { ...this.$route.query};
      if(this.num) {
        obj.region =  getSimpleCheckedNodes(this.$refs.tree.store).join(',')
      } else {
        delete obj.region;
      }
      console.log(obj)
     
    }
  },
};
</script>
<style lang="scss" scoped>
.search-tree-category{
  display: flex;
  .el-input__inner{
    height: 30px;
    line-height: 30px;
  }
  .el-tree-style1 {
    height: 300px;
    // overflow-y: auto;
  }
  .el-tree-category{
    .el-tree{
      >.el-tree-node{
        >.el-tree-node__content{
          >.el-checkbox{
            display: none;
          }
        }
      }
    }
    
  }
  .action{
    margin-top: 10px;
    text-align: center;
    .el-button{
      width: auto !important;
      min-width: 70px;
      button {
      }
    }
  }
}
:deep(.el-scrollbar__wrap){
    overflow-x: hidden;
  }
.el-dropdown-link{
  background: #FFF;
  border-radius: 2px;
  color: #222222;
  font-size: 14px;
  margin-right: 8px;
  padding: 5px 12px;
}
.activeLink{
  color: #0863ff;
}
</style>